import PropTypes from 'prop-types'

import AtomSwitch, {atomSwitchDesigns} from '@s-ui/react-atom-switch'

const FilterItemBasicSwitch = ({id, isChecked, onChange}) => (
  <AtomSwitch
    checked={isChecked}
    design={atomSwitchDesigns.SINGLE}
    id={id}
    isFitted
    name={id}
    onToggle={onChange}
    value={isChecked}
  />
)

FilterItemBasicSwitch.displayName = 'FilterItemBasicSwitch'
FilterItemBasicSwitch.propTypes = {
  id: PropTypes.string,
  isChecked: PropTypes.bool,
  onChange: PropTypes.func
}

export default FilterItemBasicSwitch
